import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

export const getProducts = (params = {}) =>
  api.get('/products', { params }).then(r => r.data);

export const getHotDealProducts = (params = {}) =>
  api.get('/products', { params: { ...params, hotDeal: true } }).then(r => r.data);

export const getProduct = (id) =>
  api.get(`/products/${id}`).then(r => r.data);

export const createProduct = (data) =>
  api.post('/products', data).then(r => r.data);

export const updateProduct = (id, data) =>
  api.put(`/products/${id}`, data).then(r => r.data);

export const deleteProduct = (id) =>
  api.delete(`/products/${id}`).then(r => r.data);

export const getMakes = () =>
  api.get('/makes').then(r => r.data);

export const getAllMakes = () =>
  api.get('/makes/all-brands').then(r => r.data);

export const getAllMakesWithModels = () =>
  api.get('/makes/all-with-models').then(r => r.data);

export const searchModels = (query) =>
  api.get('/makes/search/models', { params: { q: query } }).then(r => r.data);

// ─── Motorcycle Model APIs ───

export const getAllMotorcycleModels = (make) =>
  api.get('/motorcycle-models', { params: make ? { make } : {} }).then(r => r.data);

export const getModelsByMake = (make) =>
  api.get(`/motorcycle-models/${encodeURIComponent(make)}`).then(r => r.data);

export const searchMotorcycleModels = (query) =>
  api.get('/motorcycle-models/search', { params: { q: query } }).then(r => r.data);

export const createMotorcycleModel = (data) =>
  api.post('/motorcycle-models', data).then(r => r.data);

export const updateMotorcycleModel = (id, data) =>
  api.put(`/motorcycle-models/${id}`, data).then(r => r.data);

export const deleteMotorcycleModel = (id) =>
  api.delete(`/motorcycle-models/${id}`).then(r => r.data);

export const createMake = (data) =>
  api.post('/makes', data).then(r => r.data);

export const updateMake = (id, data) =>
  api.put(`/makes/${id}`, data).then(r => r.data);

export const deleteMake = (id) =>
  api.delete(`/makes/${id}`).then(r => r.data);

// ─── Motorcycle APIs ───

export const getMotorcycles = (params = {}) =>
  api.get('/motorcycles', { params }).then(r => r.data);

export const getMotorcycle = (id) =>
  api.get(`/motorcycles/${id}`).then(r => r.data);

export const createMotorcycle = (data) =>
  api.post('/motorcycles', data).then(r => r.data);

export const updateMotorcycle = (id, data) =>
  api.put(`/motorcycles/${id}`, data).then(r => r.data);

export const deleteMotorcycle = (id) =>
  api.delete(`/motorcycles/${id}`).then(r => r.data);

// Get motorcycle with compatible parts
export const getMotorcycleWithParts = (id) =>
  api.get(`/motorcycles/${id}`).then(r => r.data);

// ─── Hero Carousel APIs ───

export const getHeroCarouselItems = () =>
  api.get('/hero-carousel').then(r => r.data);

export const getHeroCarouselItem = (id) =>
  api.get(`/hero-carousel/${id}`).then(r => r.data);

export const createHeroCarouselItem = (data) =>
  api.post('/hero-carousel', data).then(r => r.data);

export const updateHeroCarouselItem = (id, data) =>
  api.put(`/hero-carousel/${id}`, data).then(r => r.data);

export const deleteHeroCarouselItem = (id) =>
  api.delete(`/hero-carousel/${id}`).then(r => r.data);

export default api;
